// Raw market-data API calls: FX rates, crypto prices, mutual-fund NAVs.
import { http } from "../http";

export const getExchangeRates = () => http.get(`/exchange-rates`).then((r) => r.data);

export const getCryptoPrices = () => http.get(`/crypto-prices`).then((r) => r.data);

export const searchFunds = (q) =>
  http.get(`/mf/search`, { params: { q } }).then((r) => r.data);

export const getFundNav = (code) =>
  http.get(`/mf/nav`, { params: { code } }).then((r) => r.data);

export const searchStocks = (q) =>
  http.get(`/stocks/search`, { params: { q } }).then((r) => r.data);

export const getStockQuote = (symbol) =>
  http.get(`/stocks/quote`, { params: { symbol } }).then((r) => r.data);

export const getGoldRates = () => http.get(`/gold/rates`).then((r) => r.data);
